import { formatCustomCurrency } from '../../utils/currency/formatAsCurrency';

const rewards = {
  fixed: { amount: 1000, description: 'Fixed value of reward' },
  variable_min: { amount: 2000, description: 'Minimun value of reward' },
  variable_max: { amount: 4000, description: 'Maximun value of reward' },
};

export const getReward = type => formatCustomCurrency(rewards[type].amount);
